// import { Dropdown, Modal, Collapse } from 'bootstrap';

import { forms } from './components/form-validation';
import { headerMenu } from './components/headerMenu';
import { tapInput } from './components/tapInput';
import { datepicker } from './components/datepicker';
import { mainMenu } from './components/mainMenu';
import { about } from './components/about';
import { togglePassword } from './components/togglePassword';
import { auth } from './components/auth';
import { tabs } from './components/tabs';
import { shopping } from './components/shopping';
import { textBlockHeight } from './components/textBockHeight';
import { season } from './components/season';
import { lkMenu } from './components/lkMenu';
import { dropdownInput } from './components/dropdownInput';
import { toggle } from './components/toggle';
import { mapbox } from './components/mapbox';
import { manualDatePicker } from './components/manualDatePicker';
//import { rentSlider } from './components/rentSlider';
import { dialog } from './components/dialog';
import { booking } from './components/bookingFilters';
import { catalogueMenu } from './components/catalogueMenu';

forms();
headerMenu();
tapInput();
datepicker();
mainMenu();
about();
togglePassword();
auth();
tabs();
shopping();
textBlockHeight();
season();
lkMenu();
dropdownInput();
toggle();
mapbox();
manualDatePicker();
//rentSlider();
dialog();
booking();
catalogueMenu();
